var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgLock24 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M8.798 9.744V6.672c0-.815.327-1.596.909-2.172.582-.576 1.37-.9 2.193-.9s1.612.324 2.194.9c.582.576.909 1.357.909 2.172v3.072m-8.913 0H17.71c.38 0 .69.306.69.683v8.49a.686.686 0 0 1-.69.683H6.09a.686.686 0 0 1-.69-.683v-8.49c0-.377.309-.683.69-.683Z"
  })));
});
SvgLock24.displayName = "SvgLock24";
export default SvgLock24;